module.exports = __webpack_public_path__ + "img/Logo_implementada_giz.49b10389.jpg";